import { useQuery } from '@tanstack/react-query'
import { webApi } from '@/services/webApi'
import { homeFaqs } from '@/data/mock/faq'
import type { FAQ } from '@/types/home'

export function useFaqs() {
  const query = useQuery({
    queryKey: ['web', 'faqs'],
    queryFn: webApi.faqs,
  })

  const items: FAQ[] = query.data?.length ? query.data : homeFaqs

  return { ...query, items }
}
